import { Link } from "react-router-dom";
import { LINKS, BRAND, ROUTES } from "@/config/links";
import { useLang } from "@/i18n";

/**
 * Minimal footer for the /book* booking flow — just the existing contact
 * and privacy/terms links (reused from Footer.jsx's own copy keys), no
 * sitemap columns, no social icons — per the booking-journey spec.
 */
export const CompactFooter = () => {
  const { t, l } = useLang();
  const year = new Date().getFullYear();
  const links = [
    { label: t("footer.co_contact"), to: ROUTES.contact },
    { label: t("footer.co_privacy"), to: ROUTES.privacy },
    { label: t("footer.co_terms"), to: ROUTES.terms },
  ];
  return (
    <footer className="relative z-10 bg-paper border-t border-ink/10 py-8" data-testid="book-compact-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-body text-sm text-pencil">{t("footer.copyright", { year, company: BRAND.company })}</p>
        <nav className="flex items-center gap-6 font-body text-sm text-ink-soft">
          {links.map((li) => (
            <Link key={li.to} to={l(li.to)} className="hover:text-terracotta transition-colors">
              {li.label}
            </Link>
          ))}
          <a href={LINKS.email} data-testid="book-compact-footer-email" className="hover:text-terracotta transition-colors">
            {BRAND.emailAddress}
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default CompactFooter;
